export default {
    common: {
        title: '수업 결과',
    },
    studentResult: {
        subtitle: '배운 내용을 살펴볼까요?',
        totalActivities: '총 { count }개의 활동을 했어요!',
    },
    teacherResult: {
        sessionInfo: '수업 정보',
        sessionInfoItem: {
            title: '수업 기본 정보',
            date: '날짜',
            duration: '진행시간',
            studentCount: '참여 인원',
            curriculum: '소단원',
        },
        noModules: '진행한 활동이 존재하지 않습니다.',
        showMvp: 'MVP 발표',
    },
};
